<template>
  <a-spin :spinning="loading">
    <div class="Satisfaction">
      <SeachFilter
        @changeQuery="currentQuery"
        :queryParams="queryParams"
        :exportLoading="exportLoading"
        @exportQuery="tableExport"
      />
      <a-table
        class="tableContainer"
        :columns="SatifactionColumns"
        :transformCellText="({ text }) => text ?? '--'"
        :pagination="false"
        :data-source="TableData"
        rowKey="id"
        :scroll="{ x: '100%', y: 'calc(100vh - 408px)' }"
      >
        <template #workOrderList="{ text }">
          <template v-if="text?.length">
            <text
              class="workOrderLink"
              v-for="(item, index) in text"
              :key="index"
              @click="viewDetails(item)"
            >
              {{ item }}
              <span v-if="text.length - 1 > index">,</span>
            </text>
          </template>
          <template v-else>--</template>
        </template>
        <template #assistantNameList="{ text }">
          <div v-if="text && text.length" class="assis_name">
            {{ text.join('、') }}
          </div>
          <div v-else>--</div>
        </template>
      </a-table>
      <a-row type="flex" justify="start" style="margin: 20px 0 0 20px">
        <a-col>
          <a-pagination
            v-if="Total"
            show-size-changer
            show-quick-jumper
            v-model:current="current"
            v-model:pageSize="pageSize"
            :total="Total"
            @change="listQuery"
            @showSizeChange="listQuery"
            :show-total="total => `共${Total}条`"
          />
        </a-col>
      </a-row>
      <PatientInfoDetails
        :showAllDialog="showAllDialog"
        :currentInfo="currentInfo"
        @handleCancel="handleCancel"
      />
    </div>
  </a-spin>
</template>

<script setup>
import SeachFilter from './seachFilter.vue'
import { ref, onMounted, computed } from 'vue'
import { SatifactionColumns } from './config'
import { SatisfactionPageList } from '@/api/Todo/satisfaction'
import { workOrderDetail } from '@/api/Todo/index.js'
import useTableTools from '../hooks/useTableTools'
import PatientInfoDetails from '@/components/PatientInfoDetails'
import { useFilterCache } from '@/hooks/useFilterCache'
import { FILTER_CACHE_PAGE_KEYS } from '@/constants/filterCache'
import { useStore } from 'vuex'
import { cloneDeep } from 'lodash-es'
const { Total, current, pageSize, TableData, normalizeExport } = useTableTools()

const defaultQuery = {
  id: null,
  workOrderId: null,
  assistantName: null,
  ucPatientId: null,
  patientName: null,
  evaluateStatus: null,
  evaluateResult: null,
  createdAtStart: null,
  createdAtEnd: null,
  evaluateTimeStart: null,
  evaluateTimeEnd: null
}
const store = useStore()
const { queryParams, initFromCache, updateCache } = useFilterCache({
  pageKey: FILTER_CACHE_PAGE_KEYS.SATISFACTION_LIST,
  userId: computed(() => store.state.user.userId),
  defaultParams: defaultQuery,
  normalize: params => ({
    ...cloneDeep(defaultQuery),
    ...cloneDeep(params)
  })
})

const loading = ref(false)
const listQuery = () => {
  loading.value = true
  SatisfactionPageList({
    pageNo: current.value,
    pageSize: pageSize.value,
    ...queryParams.value
  })
    .then(res => {
      const { list, totalCount } = res
      Total.value = totalCount
      TableData.value = list
    })
    .finally(() => {
      loading.value = false
    })
}

const currentQuery = params => {
  current.value = 1
  updateCache(params)
  listQuery()
}

const showAllDialog = ref(false)
const currentInfo = ref({})
const viewDetails = workOrderId => {
  loading.value = true
  workOrderDetail({ workOrderId })
    .then(res => {
      const { workOrder = {} } = res || {}
      showAllDialog.value = true
      currentInfo.value = workOrder
    })
    .finally(() => {
      loading.value = false
    })
}
const handleCancel = () => {
  showAllDialog.value = false
  currentInfo.value = {}
}

const exportLoading = ref(false)
const tableExport = async params => {
  exportLoading.value = true
  await normalizeExport(
    '/health-doctor-assistant/satisfactionEvaluation/list/export',
    params,
    '满意度评价',
    'post'
  )
  exportLoading.value = false
}

onMounted(() => {
  initFromCache()
  listQuery()
})
</script>

<style lang="scss" scoped>
.Satisfaction {
  height: 100%;
}
.Satisfaction .tableContainer {
  padding: 10px 20px 0;
  .workOrderLink {
    cursor: pointer;
    color: #1890ff;
  }
  // .assis_name {
  //   overflow: hidden;
  //   text-overflow: ellipsis;
  //   display: -webkit-box;
  //   -webkit-box-orient: vertical;
  //   -webkit-line-clamp: 2;
  // }
}
</style>
